import { API_ENDPOINTS } from "@features/tickets/config/constants";
import type { Ticket } from "@features/tickets/types/ticket.types";
import api from "@lib/api/client";
import { queryKeys } from "@lib/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

interface TicketListResponse {
  readonly member: readonly Ticket[];
  readonly totalItems: number;
}

interface TicketFilters {
  readonly status?: string;
  readonly category?: string;
  readonly creator?: number;
  readonly page?: number;
  readonly itemsPerPage?: number;
}

export function useTickets(filters: TicketFilters = {}) {
  return useQuery({
    queryKey: queryKeys.tickets.list(filters as Record<string, unknown>),
    queryFn: async () => {
      const response = await api.get<TicketListResponse>(API_ENDPOINTS.TICKETS.LIST, {
        params: { itemsPerPage: 20, ...filters },
      });
      return response.data;
    },
  });
}

export function useTicket(id: number | string) {
  return useQuery({
    queryKey: queryKeys.tickets.detail(id),
    queryFn: async () => {
      const response = await api.get<Ticket>(API_ENDPOINTS.TICKETS.DETAIL(id));
      return response.data;
    },
    enabled: !!id,
  });
}
